<template>
<el-container class="full-height bg-gray">
      <el-main class="container">
        <Nav>
          <div slot="right">
            <el-button v-show="hasAuthority('addConsult')" type="primary" @click="handleAddConsult">新增推送</el-button>
          </div>
        </Nav>
        <div class="table">
          <Table
            border
            align="center"
            :header-row-style="{height: '100px'}"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            :row-style="{height: '150px'}"
            :column="column"
            :data="datasource.data"
            pagination
            background
            :paginationTop="'30px'"
            :paginationAlign="'center'"
            layout="prev, pager, next, sizes, jumper"
            :page-sizes="[5, 10, 20, 30]"
            :pager-count="5"
            :current-page.sync="body.pageIndex"
            :total="datasource.total"
            :page-size="body.pageSize"
            @size-change="handleSizeChange"
            @p-current-change="handleCurrentChange"
          >
          </Table>
      </div>
      </el-main>
</el-container>
</template>

<script>
import {
  getConsultList,
  deleteConsult,
  setConsult
} from '@/api/basic'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        industryUuid: ''
      },
      datasource: {
        total: 0,
        data: []
      },
      column: [
        {
          prop: 'content',
          label: '资讯内容'
        },
        {
          prop: 'startTime',
          label: '发布时间'
        },
        {
          prop: 'industryName',
          label: '发布产业'
        },
        {
          label: '操作',
          width: '300',
          render: (h, scoped) => {
            let text = ''
            parseInt(scoped.row.status) === 0 ? text = '隐藏' : text = '显示'
            return (
              <div>
                <el-link v-show={this.hasAuthority('showConsult')} underline={false} type='primary' onClick={() => { this.handleShow(scoped.row) }}>{text}</el-link>&nbsp;&nbsp;
                <el-link v-show={this.hasAuthority('editConsult')} underline={false} type='primary' onClick={() => { this.handleDetail(scoped.row) }}>编辑</el-link>&nbsp;&nbsp;
                <el-link v-show={this.hasAuthority('deleteConsult')} underline={false} type='primary' onClick={() => { this.handleDelete(scoped.row) }}>删除</el-link>
              </div>
            )
          }
        }
      ]
    }
  },
  created() {
    this.network().getConsultList()
  },
  methods: {
    network() {
      return {
        getConsultList: async(page) => {
          if (page) {
            this.body.pageIndex = page
          }
          const { data } = await getConsultList(this.body)
          this.datasource.data = data.list
          this.datasource.total = data.total
        },
        deleteConsult: async(id) => {
          await deleteConsult(id)
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.network().getConsultList(1)
        },
        setConsult: async(id) => {
          await setConsult(id)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.network().getConsultList(1)
        }
      }
    },
    handleAddConsult() {
      this.$router.push('/basic-management/consult-list/add')
    },
    handleSizeChange() {

    },
    handleCurrentChange() {

    },
    handleDelete(row) {
      this.$confirm('是否删除系统消息推送？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteConsult(row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleShow(row) {
      this.network().setConsult(row.uuid)
    },
    handleDetail(row) {
      this.$router.push({
        path: '/basic-management/consult-list/set',
        query: {
          id: row.uuid
        }
      })
    }
  }
}
</script>

<style>

</style>
